/**
 * Embedded Wizard Configuration
 * Defines sub-wizard steps for each search experience type
 */

const EXPERIENCE_STEPS = {
  unified: [
    {
      id: 'dropdown-config',
      titleKey: 'wizard.searchSetup.configuration.searchWidget.title',
      descriptionKey: 'wizard.searchSetup.configuration.searchWidget.description',
      validate: () => true, // Always valid for demo
    },
    {
      id: 'resultspage-config',
      titleKey: 'wizard.searchSetup.configuration.resultsPage.title',
      descriptionKey: 'wizard.searchSetup.configuration.resultsPage.description',
      validate: () => true,
    },
  ],

  fullpage: [
    {
      id: 'searchbox-config',
      titleKey: 'wizard.searchSetup.configuration.searchWidget.title',
      descriptionKey: 'wizard.searchSetup.configuration.searchWidget.description',
      validate: () => true,
    },
    {
      id: 'resultspage-config',
      titleKey: 'wizard.searchSetup.configuration.resultsPage.title',
      descriptionKey: 'wizard.searchSetup.configuration.resultsPage.description',
      validate: () => true,
    },
  ],

  classic: [
    {
      id: 'classic-config',
      titleKey: 'wizard.searchSetup.configuration.classic.title',
      descriptionKey: 'wizard.searchSetup.configuration.classic.description',
      validate: () => true,
    },
    {
      id: 'resultspage-config',
      titleKey: 'wizard.searchSetup.configuration.resultsPage.title',
      descriptionKey: 'wizard.searchSetup.configuration.resultsPage.description',
      validate: () => true,
    },
  ],
};

/**
 * Get steps for specific experience type
 */
export const getStepsForExperience = (experienceType) => EXPERIENCE_STEPS[experienceType] || [];

/**
 * Check if step is valid
 */
export const isStepValid = (step, data) => (step.validate ? step.validate(data) : true);

export default {
  getStepsForExperience,
  isStepValid,
};
